import React, { FC, useEffect, useState } from "react";
import { Input, Button } from "design_system/src";
import { ReactComponent as Eye } from "design_system/src/static/icons/eye.svg";
import { ReactComponent as EyeOff } from "design_system/src/static/icons/eye-off.svg";
import "./PasswordInput.scss";

interface PasswordInputProps {
    title: string;
    name: string;
    placeholder: string;
    value?: string;
    onBlur: any;
    onChange: any;
    error?: boolean;
	subtitle?: string;
    showErrors?: boolean;
}

export const PasswordInput: FC<PasswordInputProps> = ({
    title,
    name,
    placeholder,
    value,
    onBlur,
    onChange,
    error,
	subtitle,
    showErrors = true
}) => {
    const [eyeOff, setEyeOff] = useState<boolean>(false);
    const [inputType, setInputType] = useState<"password" | "text">("password");

    useEffect(() => {
        setInputType(eyeOff ? "text" : "password");
    }, [eyeOff]);

    return <div className="password-input display_flex flex_align_start">
        <div className="flex_grow_1">
            <Input
                title={title}
                name={name}
                type={inputType}
                placeholder={placeholder}
                value={value}
                onBlur={onBlur}
                onChange={onChange}
                error={error}
                subtitle={showErrors ? subtitle : ""}
            />
        </div>
        <div className="p_t_md">
            <button className={`password-input__button${title ? " with-title" : ""}`} type="button" onClick={() => setEyeOff(!eyeOff)}>
                {!eyeOff && <Eye className="password-input__icon" />}
                {eyeOff && <EyeOff className="password-input__icon" />}
            </button>
        </div>
    </div>;
};
